import { UrlHandlingStrategy, UrlTree } from '@angular/router';
import { routeHelpers } from './route-helpers/routes-helpers';

export class Ng1Ng2UrlHandlingStrategy implements UrlHandlingStrategy {
  shouldProcessUrl(url: UrlTree): boolean {
    const activeUrl = url.toString();
    const routeUrls = routeHelpers.getRoutesUrls();
    return routeUrls.some(ng2Url => activeUrl.indexOf(ng2Url) > -1);
  }

  extract(url: UrlTree): UrlTree {
    return url;
  }

  merge(newUrlPart: UrlTree): UrlTree {
    return newUrlPart;
  }
}
